import { IconPropTypes } from '@/legacy/types';

const DeviceIcon = ({ width = 16, height = 16, color, scale = 1 }: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 16 16`}
			fill='none'
			preserveAspectRatio='xMidYMid meet'
		>
			<g
				strokeLinecap='round'
				strokeLinejoin='round'
				clipPath='url(#a)'
				strokeWidth={1.143 * scale}
				transform={`scale(${scale})`}
				style={{ transformOrigin: 'center' }}
			>
				<path
					stroke={color || 'currentColor'}
					d='M8 4a.286.286 0 1 1 0-.572M8 4a.286.286 0 0 0 0-.572'
				/>
				<path
					stroke={color || 'currentColor'}
					strokeWidth={1.15}
					d='M12 .571H4c-.63 0-1.143.512-1.143 1.143v12.572c0 .63.512 1.142 1.143 1.142h8c.632 0 1.143-.511 1.143-1.142V1.714c0-.631-.511-1.143-1.143-1.143Z'
				/>
			</g>
			<defs>
				<clipPath id='a'>
					<path
						fill='#fff'
						d='M0 0h16v16H0z'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default DeviceIcon;
